import styled from "styled-components";
import MatchStat from "./MatchStat";
import { FC, useEffect, useState } from "react";
import { Fixture } from "../../../models/fixture";
import { Team } from "../../../models/team";
import placeholderImage from "../../../images/common/vgc-logo.png"
import { useLeague } from "../../../context/useLeague";
import { FixtureStats } from "../../../models/leagueStats";

interface Props {
  fixture: Fixture
  team: Team
}

const MatchStats: FC<Props> = ({ fixture, team }) => {
  const { leagueStats } = useLeague();
  const [fixtureStats, setFixtureStats ] = useState<FixtureStats>();

  useEffect(() => {
    if (!leagueStats) {
      return;
    }
    const stats = leagueStats.fixtureStats.find((stat) => stat.fixtureId === fixture._id)
    if (!stats) {
      return;
    }
    setFixtureStats(stats)
  }, [leagueStats?.topPerformers]);


  return (
    <>
        <Container>
          <Header>
            <TeamContainer>
              <Img src={fixture.homeImage || placeholderImage}></Img>
              <ImgText>{fixture.home}</ImgText>
            </TeamContainer>
            <Title>
              <Bold>
                {fixture.homeScore} - {fixture.awayScore}
              </Bold>
            </Title>
            <TeamContainer>
              <Img src={fixture.awayImage ||placeholderImage}></Img>
              <ImgText> {fixture.away}</ImgText>
            </TeamContainer>
          </Header>
          <Body>
            <MatchStat
              homeScore={fixture.homeScore}
              awayScore={fixture.awayScore}
              statName={"Goals"}
            />
            <MatchStat
            homeScore={fixtureStats?.homeTeamStats.assists || 0}
              awayScore={fixtureStats?.awayTeamStats.assists || 0}
              statName={"Assists"}
            />
            <MatchStat
              homeScore={fixtureStats?.homeTeamStats.passes || 0}
              awayScore={fixtureStats?.awayTeamStats.passes || 0}
              statName={"Passes"}
            />
            <MatchStat
              homeScore={fixtureStats?.homeTeamStats.tackles || 0}
              awayScore={fixtureStats?.awayTeamStats.tackles || 0}
              statName={"Tackles"}
            />
            <MatchStat
              homeScore={fixtureStats?.homeTeamStats.interceptions || 0}
              awayScore={fixtureStats?.awayTeamStats.interceptions || 0}
              statName={"Interceptions"}
            />
            <MatchStat
              homeScore={fixtureStats?.homeTeamStats.headers || 0}
              awayScore={fixtureStats?.awayTeamStats.headers || 0}
              statName={"Headers"}
            />
            <MatchStat
              homeScore={fixtureStats?.homeTeamStats.saves || 0}
              awayScore={fixtureStats?.awayTeamStats.saves || 0}
              statName={"Saves"}
            />
            <MatchStat
              homeScore={fixtureStats?.homeTeamStats.cleanSheets || 0}
              awayScore={fixtureStats?.awayTeamStats.cleanSheets || 0}
              statName={"Clean Sheets"}
            />
          </Body>
        </Container>
    </>
  );
};
export default MatchStats;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 85vw;
  max-width: 370px;
  padding: 0 0.5rem;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-around; // Adjusted for better spacing
  align-items: center;
  margin-top: 1rem;
`;

const TeamContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 60px;
`;

const Img = styled.img`
  height: 60px;
  width: 60px;
  object-fit: cover; // Ensure images are nicely fitted
  border-radius: 50%; // Circle shape
`;

const ImgText = styled.div`
  font-size: small;
  font-weight: 500;
  letter-spacing: 0.02rem;
  text-align: center;
  margin-top: 0.5rem;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Bold = styled.span`
  font-weight: bold;
  margin: 0 0.5rem;
  font-size: x-large;
`;

const Body = styled.div`
  padding: 0 1.5rem;
  margin-top: 2rem;
`;